import { DSNotifications } from '../../../cimsPage/instances/ds'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: DSNotifications,
  view: '1DE20E85-CDD8-4B30-9E1A-6BF3054732F0',
  edit: 'CA170988-5130-4C57-9C4D-38EABD44946E',
})

export const ViewDSNotification = View
export const EditDSNotification = Edit

export type DSNotificationPermission =
  | typeof ViewDSNotification
  | typeof EditDSNotification
